import { Component, input, model, OnInit } from '@angular/core';

/**
 * A generic dialog component that acts as a baseline for other dialogs components.
 */
@Component({
    selector: 'emr-dialog',
    templateUrl: './emr-dialog.component.html',
    styleUrls: ['./emr-dialog.component.scss'],
    standalone: true,
})
export class EmrDialogComponent implements OnInit {
  /**
   * The title to display in the dialog's header.
   */
  title = input('');

  /**
   * Whether the dialog should be displayed or not.
   */
  display = model.required<boolean>();

  // Common presets for all dialogs that extend this one.
  isModal = true;
  isDraggable = false;
  isResizable = false;

  ngOnInit(): void {}

  /**
   * This function should be overridden by derived classes. It
   * tells the parent to close the dialog and emit a value
   * back to it.
   *
   * @param valToReturn The value that is emitted back to the parent component.
   */
  closeDialog(valToReturn?: any) {
    this.display.set(false);
  }
}
